import {
  CustomFieldValues,
  FieldAttributes,
} from '~/legacy-components/CustomDataFields';
import { fetchFromOldApi } from '~/services/Http';

import { AnswerPreProcess } from '../../../../types';

export { prefetchCustomPosition } from './prefetchCustomPosition';

export const getCustomEmployeePositionFields = (
  id: string,
): Promise<CustomFieldValues> => {
  return fetchFromOldApi(`/json/customdata/EMPLOYEE_POS/${id}`).then((r) =>
    r.json(),
  );
};

export const getCustomEmployeePositionFieldAttributes = (): Promise<
  FieldAttributes[]
> => {
  return fetchFromOldApi(`/json/customdata/entity/EMPLOYEE_POS/attribute`).then(
    (r) => r.json(),
  );
};

export const getCustomEmployeePositionFieldLanguages = (
  strLang: string,
  includeInactive = false,
): Promise<[]> => {
  return fetchFromOldApi(
    `/json/enum/CUSTOM_ENTITY_EMPLOYEE_POS/${strLang}?includeInactive=${includeInactive}`,
  ).then((r) => r.json());
};

export const saveCustomFieldValues = (
  employeeId: string,
  customFieldValues: AnswerPreProcess,
) => {
  return fetchFromOldApi(`/json/customdata/EMPLOYEE_POS/${employeeId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Accept: 'application/json; text/javascript; */*; q=0.01',
    },
    body: JSON.stringify(customFieldValues),
  }).then((r) => r.json());
};
